// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2qCrG","addWidgetButton":"Header_addWidgetButton__3PT58","dashboardTabs":"Header_dashboardTabs__2-Pvw","active":"Header_active__2qAPR"};